module.exports = __webpack_public_path__ + "static/media/checkbox_checked.388f39d0.svg";